import { render } from "./AllFAQCategories.vue?vue&type=template&id=3c344188"
import script from "./AllFAQCategories.vue?vue&type=script&lang=js"
export * from "./AllFAQCategories.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__